// BottomSheet gibi geçici overlay'ler açıkken global popstate router'ının
// URL'yi yeniden çözüp SAYFA DEĞİŞTİRMESİNİ engelleyen paylaşılan guard.
//
// Neden gerekli:
//   BottomSheet açılırken history.pushState ile bir giriş ekler (URL'yi
//   DEĞİŞTİRMEDEN — Android geri tuşu sayfadan çıkmadan sheet'i kapatsın diye).
//   Scrim'e/boşluğa tıklayıp kapatınca history.back() çağrılır; bu popstate
//   global router'ı (usePopstateHandler) tetikler ve o anki URL'yi yeniden
//   çözer. Profilden haritaya geçişte URL "/u/<kullanıcı>" olarak KALIYOR
//   (harita sekmesinin kendi URL'si yok); sheet kapanınca router bu bayat
//   URL'yi "profile" çözüp beklenmedik şekilde profil sayfasını açıyordu.
//   Sheet görünürken gelen pop = "overlay'i kapat" demektir, sayfa navigasyonu
//   DEĞİL → bu sırada route yeniden-çözme atlanır.
let openSheets = 0;

export function enterSheet(): void {
  openSheets += 1;
}

export function exitSheet(): void {
  openSheets = Math.max(0, openSheets - 1);
}

export function isSheetRouteActive(): boolean {
  return openSheets > 0;
}

/**
 * Kapanış pop'unu kapsayan SINIRLI SÜRELİ susturma penceresi.
 *
 * ── NİYE VAR (#1021, gerçek Chromium'da ölçüldü) ────────────────────────
 * Bir katman `history.back()` ile kapanınca pop ASENKRON gelir; o pop'ta
 * global router (`usePopstateHandler`) altta duran adresi SOĞUK DERİN
 * BAĞLANTI sanıp bir modal/sayfa açıyordu. Katmanların kendi
 * `capture: true` + `stopImmediatePropagation()` koruması bunu ENGELLEMEZ:
 * `popstate` doğrudan `window`a atılır → faz **AT_TARGET** → orada `capture`
 * bayrağı YOK SAYILIR ve dinleyiciler **kayıt sırasına** göre koşar. Router
 * App mount'unda kaydolur, katman sheet mount'unda → router DAİMA ÖNCE.
 * Ölçüm (`about:blank`, gerçek Chromium):
 *     sıra   = ["router", "katman(capture+SIP)"]
 *     fazlar = [AT_TARGET, AT_TARGET]
 * Aynı senaryo jsdom'da `["katman(capture+SIP)"]` veriyor — yani jsdom
 * korumayı ÇALIŞIYOR gösteriyor. Bu yüzden hüküm gerçek tarayıcıda kuruldu.
 *
 * ── NİYE PENCERE, NİYE "KATMAN AÇIKKEN SÜREKLİ" DEĞİL ───────────────────
 * Sürekli tutmak ÖLÇÜLEREK ELENDİ: `ProfileView.navigateMainApp` katman
 * GÖRÜNÜRKEN `pushState(hedef)` + **sentetik popstate** atar ve router'ın
 * onu çözmesini İSTER ("Klip Analitiğim" / "Engellenenler"). Sayaç o an
 * yukarıdaysa gezinme HİÇBİR YERE GİTMEZ. Yani "her katman, görünürken
 * guard tutsun" kuralı bir kusuru kapatırken başka birini açar.
 * (GÖZ sahnesi `86-katman-kapanisi-router` bunu KONTROL kolu olarak ölçer.)
 *
 * ── SIZINTI ─────────────────────────────────────────────────────────────
 * Zamanlayıcı sayacı KOŞULSUZ bırakır; pop hiç gelmese bile sızıntı olmaz.
 * Bırakmayı kendi pop dinleyicimize bağlamak, kusurun TA KENDİSİ olan sıra
 * sorununa geri düşmek olurdu (bkz. `useAdressizKatmanGeri` KAPI_SALIVERME_MS).
 * 300 ms uydurulmadı: `BottomSheet` ve `useAdressizKatmanGeri` aynı sayacı
 * aynı pencereyle tutuyor — tek sözleşme.
 */
export function susturRouterPopIcin(ms = 300): void {
  enterSheet();
  try {
    setTimeout(exitSheet, ms);
  } catch (_) {
    // Zamanlayıcı yoksa sayacı ANINDA bırak — sızan +1, global router'ın
    // popstate'ini KALICI olarak öldürür (susturmanın en pahalı yolu).
    exitSheet();
  }
}
